<template>
  <div class="node" :style="{ marginLeft: depth * 1 + 'rem' }">
    <div class="container">
      <!-- code here -->
      <div
        class="menu-item w-full"
        :class="{
          'container--country': type == 'country',
          'container--state': type == 'state',
          'container--district': type == 'district',
          'container--city': type == 'city',
          'container--time': type == 'time',
        }"
        @click="expanded = !expanded"
      >
        <span class="menu-button menu-button--black">
          <span
            :class="{
              type: true,
              'mr-3': true,
            }"
            v-if="hasChildren"
            ><img
              v-if="expanded"
              src="@/assets/images/icons/icons8-reduce-17.png" />
            <img v-else src="@/assets/images/icons/plus-box-bg.svg" /></span
          >{{ node.name }}</span
        >
        <div class="menu-sub-list" v-if="node.id != ''">
          <span
            class="menu-item"
            v-if="
              type == 'country' &&
              (node.allowedChild.includes('year') ||
                node.allowedChild.includes('month') ||
                node.allowedChild.includes('day') ||
                node.allowedChild.includes('time'))
            "
          >
            <button
              class="menu-button menu-button--orange"
              @click="addIn(getCountryLabel(node), depth)"
            >
              <feather-icon
                icon="PlusCircleIcon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="add_icon"
              />
              {{$t("setup.label.Add")}} {{ getCountryLabel(node) }}
            </button>
          </span>
          <span
            class="menu-item"
            v-if="
              type == 'state' &&
              (node.allowedChild.includes('month') ||
                node.allowedChild.includes('day') ||
                node.allowedChild.includes('time'))
            "
          >
            <button
              class="menu-button menu-button--orange"
              @click="addIn(getStateLabel(node), depth)"
            >
              <feather-icon
                icon="PlusCircleIcon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="add_icon"
              />
              {{$t("setup.label.Add")}} {{ getStateLabel(node) }}
            </button>
          </span>
          <span
            class="menu-item"
            v-if="
              type == 'district' &&
              (node.allowedChild.includes('day') ||
                node.allowedChild.includes('time'))
            "
          >
            <button
              class="menu-button menu-button--orange"
              @click="addIn(getDistrictLabel(node), depth)"
            >
              <feather-icon
                icon="PlusCircleIcon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="add_icon"
              />
              {{$t("setup.label.Add")}} {{ getDistrictLabel(node) }}
            </button>
          </span>
          <span
            class="menu-item"
            v-if="type == 'city' && node.allowedChild.includes('time')"
          >
            <button
              class="menu-button menu-button--orange"
              @click="addIn(getCityLabel(node), depth)"
            >
              <feather-icon
                icon="PlusCircleIcon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="add_icon"
              />
              {{$t("setup.label.Add")}} {{ getCityLabel(node) }}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'country'">
            <button
              class="menu-button menu-button--orange"
              @click="edit('country', depth)"
            >
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.Edit_TimeModel")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'state'">
            <button
              class="menu-button menu-button--orange"
              @click="edit('state', depth)"
            >
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.Edit_Year")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'district'">
            <button
              class="menu-button menu-button--orange"
              @click="edit('district', depth)"
            >
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.Edit_Month")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'city'">
            <button
              class="menu-button menu-button--orange"
              @click="edit('city', depth)"
            >
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.Edit_Day")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'time'">
            <button
              class="menu-button menu-button--orange"
              @click="edit('time', depth)"
            >
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.Edit_Time")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'country'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem('country', depth)"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{$t("setup.label.Delete_TimeModel")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'state'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem('state', depth)"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{$t("setup.label.Delete_Year")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'district'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem('district', depth)"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{("setup.label.Delete_Month")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'city'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem('city', depth)"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{$t("setup.label.Delete_Day")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'time'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem('time', depth)"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{$t("setup.label.Delete_Time")}}
            </button>
          </span>
        </div>
      </div>
    </div>

    <TreeItem
      v-if="expanded"
      v-for="child in node.children"
      :key="child.name"
      :node="child"
      :depth="depth + 1"
    />
  </div>
</template>
<script>
export default {
  name: "TreeItem",
  props: {
    node: Object,
    depth: {
      type: Number,
      default: 0,
    },
    emits: ["add-state"],
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    getCountryLabel(node) {
      if (node.allowedChild.includes("year")) return "Year";
      if (node.allowedChild.includes("month")) return "Month";
      if (node.allowedChild.includes("day")) return "Day";
      if (node.allowedChild.includes("time")) return "Time";
      return "";
    },
    getStateLabel(node) {
      if (node.allowedChild.includes("month")) return "Month";
      if (node.allowedChild.includes("day")) return "Day";
      if (node.allowedChild.includes("time")) return "Time";
      return "";
    },
    getDistrictLabel(node) {
      if (node.allowedChild.includes("day")) return "Day";
      if (node.allowedChild.includes("time")) return "Time";
      return "";
    },
    getCityLabel(node) {
      if (node.allowedChild.includes("time")) return "Time";
      return "";
    },
    hi() {
      alert("Hi");
    },
    getPath(val) {
      if (val) {
        return "@/assets/images/icons/plus-box.svg";
      } else {
        return "@/assets/images/icons/plus-box-bg.svg";
      }
    },
    addIn(type, depth) {
      if (depth == 1)
        this.$parent.$emit(
          "add-in",
          this.node.id,
          type,
          this.node.code,
          this.node.modelId,
          this.node.dis
        );
      if (depth == 2)
        this.$parent.$parent.$emit(
          "add-in",
          this.node.id,
          type,
          this.node.code,
          this.node.modelId,
          this.node.dis
        );
      if (depth == 3)
        this.$parent.$parent.$parent.$emit(
          "add-in",
          this.node.id,
          type,
          this.node.code,
          this.node.modelId,
          this.node.dis
        );
      if (depth == 4)
        this.$parent.$parent.$parent.$parent.$emit(
          "add-in",
          this.node.id,
          type,
          this.node.code,
          this.node.modelId,
          this.node.dis
        );
    },
    edit(type, depth) {
      if (depth == 1)
        this.$parent.$emit(
          "edit-item",
          this.node.id,
          type,
          this.node.code,
          this.node.name,
          this.node.end,
          this.node
        );
      if (depth == 2)
        this.$parent.$parent.$emit(
          "edit-item",
          this.node.id,
          type,
          this.node.code,
          this.node.name,
          this.node.end,
          this.node
        );
      if (depth == 3)
        this.$parent.$parent.$parent.$emit(
          "edit-item",
          this.node.id,
          type,
          this.node.code,
          this.node.name,
          this.node.end,
          this.node
        );
      if (depth == 4)
        this.$parent.$parent.$parent.$parent.$emit(
          "edit-item",
          this.node.id,
          type,
          this.node.code,
          this.node.name,
          this.node.end,
          this.node
        );
      if (depth == 5)
        this.$parent.$parent.$parent.$parent.$parent.$emit(
          "edit-item",
          this.node.id,
          type,
          this.node.code,
          this.node.name,
          this.node.end
        );
    },

    deleteItem(type, depth) {
      if (depth == 1)
        this.$parent.$emit("delete-item", this.node.id, type, this.node.code);
      if (depth == 2)
        this.$parent.$parent.$emit(
          "delete-item",
          this.node.id,
          type,
          this.node.code
        );
      if (depth == 3)
        this.$parent.$parent.$parent.$emit(
          "delete-item",
          this.node.id,
          type,
          this.node.code
        );
      if (depth == 4)
        this.$parent.$parent.$parent.$parent.$emit(
          "delete-item",
          this.node.id,
          type,
          this.node.code
        );
      if (depth == 5)
        this.$parent.$parent.$parent.$parent.$parent.$emit(
          "delete-item",
          this.node.id,
          type,
          this.node.code
        );
    },
    serviceAvailable() {
      if (this.node.type == "country")
        this.$parent.$emit(
          "service-available",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "state")
        this.$parent.$parent.$emit(
          "service-available",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "district")
        this.$parent.$parent.$parent.$emit(
          "service-available",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "city")
        this.$parent.$parent.$parent.$parent.$emit(
          "service-available",
          this.node.id,
          this.node.type,
          this.node.code
        );
    },
  },
  computed: {
    hasChildren() {
      return this.node.children;
    },
    type() {
      return this.node.type;
    },
    id() {
      return this.node.id;
    },
  },
};
</script>
<style lang="scss" scoped>
.add_icon {
  color: rgba(var(--vs-success), 1);
}
.edit_icon {
  color: rgba(var(--vs-warning), 1);
}
.delete_icon {
  color: rgba(var(--vs-danger), 1);
}
.service_icon {
  color: rgba(var(--vs-primary), 1);
}
.node {
  text-align: left;
}
.menu-sub-list {
  display: none;
  padding: 5px;
  background-color: #fbfbfb;
  border-radius: 5px;
  box-shadow: 0 10px 20px rgba(#404040, 0.15);
  position: absolute;
  left: 100%;
  right: 0;
  z-index: 1000;
  width: 15.5rem;
  top: 0;
  flex-direction: column;
  // &:after {
  //   content: "";
  //   position: absolute;
  //   left: -12px;
  //   top: 0;
  //   right: 0;
  //   bottom: 0;
  //   display: block;
  //   outline: 2px solid hotpink;
  // }
  &:hover {
    display: flex;
  }
}

.menu-item {
  position: relative;
}

.menu-button {
  font: inherit;
  border: 0;
  padding: 8px 8px;
  padding-right: 0;
  width: 100%;

  text-align: left;
  display: flex;
  align-items: center;
  position: relative;
  background-color: var(--color-bg-secondary);
  border: solid rgba(0, 0, 0, 0.2);
  &:hover {
    .add_icon,
    .edit_icon,
    .delete_icon,
    .service_icon {
      color: #fff;
    }
    background: rgba(var(--vs-primary), 0.2);
    & + .menu-sub-list {
      display: flex;
    }
    svg {
      stroke: var(--color-text-primary);
    }
  }
  svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    stroke: var(--color-text-primary-offset);
    &:nth-of-type(2) {
      margin-right: 0;
      position: absolute;
      right: 8px;
    }
  }

  &--delete {
    &:hover {
      color: var(--color-red);
      svg:first-of-type {
        stroke: var(--color-red);
      }
    }
  }

  &--orange {
    svg:first-of-type {
      stroke: var(--color-orange);
    }
  }

  &--green {
    svg:first-of-type {
      stroke: var(--color-green);
    }
  }
  &--purple {
    svg:first-of-type {
      stroke: var(--color-purple);
    }
  }
  &--black {
    svg:first-of-type {
      stroke: var(--color-black);
    }
  }

  &--checked {
    svg:nth-of-type(2) {
      stroke: var(--color-purple);
    }
  }
}

// Codepen spesific styling - only to center the elements in the pen preview and viewport
.container {
  display: flex;
  align-items: left;
  justify-content: left;
  transition: all 0.5s;
  margin: 5px;
  cursor: pointer;
  padding-right: 0;
  margin-right: 0;
  &--country {
    max-width: 28rem;
    background: darken($color: #fff, $amount: 1);
    margin-right: 0;
  }
  &--state {
    max-width: 26rem;
    margin-right: 0;
    background: darken($color: #fff, $amount: 4);
  }
  &--district {
    max-width: 23rem;
    margin-right: 0;
    background: darken($color: #fff, $amount: 7);
  }
  &--city {
    max-width: 19rem;
    margin-right: 0;
    background: darken($color: #fff, $amount: 10);
  }
  &--time {
    max-width: 14rem;
    margin-right: 0;
    background: darken($color: #fff, $amount: 13);
  }
  &:hover {
    transform: translateX(0.5rem);
  }
}
// End Codepen spesific styling
// End Codepen spesific styling
</style>
